import { makeStyles, theme } from 'cdh-data-portal-theme'
import { TOPBAR_HEIGHT, TOP_MARGIN } from '../Topbar/Topbar.static'
import { SIDEBAR_WIDTH } from './Sidebar.static'

const TOPBAR_TOTAL = TOP_MARGIN + theme.globalPadding + TOPBAR_HEIGHT

export const useStyles = makeStyles()(() => ({
  drawer: {
    position: 'fixed',
    top: TOPBAR_TOTAL + 8,
    left: theme.globalPadding,
    bottom: theme.globalPadding,
    width: SIDEBAR_WIDTH,
    background: 'white',
    borderRadius: 8,
    boxShadow: theme.shadows.medium,
    zIndex: theme.zIndex.rightSidebar,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  content: {
    padding: `${theme.globalPadding}px 0`,
    flex: 1,
    overflowY: 'auto',
  },
}))
